/* eslint-disable eqeqeq */

import { Formik, Form } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  // lowQuantityToast,
  somethingWentWrongToast,
  sweetAlert,
} from "../../../components/NotificationToast";
// import { DashboardContext } from "../../../Context/DashboardContext";
// import { DmsContext } from "../../../Context/DmsContext";
// import { ProductContext } from "../../../Context/ProductContext";
// import { createOrderSchema } from "../../../Hooks/Schema";
import { SelectField } from "../../../Hooks/SelectField";
import {
  addCode,
  loadCylinders,
  loadCylinderSize,
  loadPlants,
} from "../../../redux/admin/actions/admin.actions";
import { MyButton, MyTextInput } from "../../../Hooks/TextInput";
// import { addCode } from "../../../services";
// import { addOrder } from "../../../services";
import "./AddForm.styles.scss";

const AddBatch = (props) => {
  // const { plants, size } = useContext(DashboardContext);
  const [plantsDrop, setPlantsDrop] = useState();
  const [sizeDrop, setSizeDrop] = useState();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { plants, size } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    setLoading(true);
    dispatch(loadCylinderSize()).then(() => {
      dispatch(loadPlants());
    });
    setLoading(false);
  }, [dispatch]);

  useEffect(() => {
    let options = plants?.map((p) => ({
      label: p?.name,
      value: p?.id,
    }));

    setPlantsDrop(options);
  }, [plants]);

  useEffect(() => {
    let options = size?.map((p) => ({
      label: p?.size,
      value: p?.id,
    }));

    setSizeDrop(options);
  }, [size]);

  const onAdd = (values) => {
    values.owner = values.owner.value;
    values.size_id = values.size_id.value;

    dispatch(addCode(values)).then((response) => {
      if (
        response?.status === 200 ||
        response?.data?.data === "cylinder has been created"
      ) {
        localStorage.setItem("batch", response?.data?.batch);
        props.onClickYes();
        sweetAlert(
          "Cylinder has been created",
          `cylinders/${response?.data?.batch}`
        );
      } else {
        somethingWentWrongToast();
      }
      // console.log("res", response?.data);
    });
  };

  return (
    <>
      <Formik
        initialValues={{
          size_id: "",
          owner: "",
          qty: "",
        }}
        // validationSchema={createOrderSchema}
        onSubmit={onAdd}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <h4 className='form-header text-center'>ADD BATCH</h4>
            <div className='select-container'>
              <p className='select-label mt-3'>Plant</p>
              <div className='w-100 mt-2'>
                <SelectField
                  name='owner'
                  options={plantsDrop}
                  onChange={setFieldValue}
                  placeholder='Select Plant'
                  onBlur={handleBlur}
                />
              </div>{" "}
            </div>

            <div className='select-container'>
              <p className='select-label mt-3'>Cylinder Size</p>
              <div className='w-100 mt-2 mb-3'>
                <SelectField
                  name='size_id'
                  options={sizeDrop}
                  onChange={setFieldValue}
                  placeholder='Select Cylinder'
                  onBlur={handleBlur}
                />
              </div>{" "}
            </div>

            <MyTextInput
              label='Quantity'
              name='qty'
              type='number'
              placeholder='1'
            />

            <MyButton disabled={isSubmitting} loader={isSubmitting} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddBatch;
